<template>
  <div class="pf pr proTreeCon" v-if="visible">
    <div class="inProTreeCon pa center f14" id="fullScreen">
      <h3 class="tal pr"><b>【{{ curData.pcName }}】-{{ curData.barName }}[{{ curData.barId }}]</b>进程树
        <span style="margin-left:40px;" @click="visibleTime = true">开机时间：{{ curData.osStartTime }}</span>
        <span class="fr mainCol cp underLine" v-if="$store.state.user.isCanUseTreeHistory"  style="margin-right: 40px;">历史进程树</span>
        <div class="expend pa">
          <Icon type="md-expand" class=" f20 cp" @click="expendFn" />
        </div>
      </h3>
      <div class="inCon">
        <div class="searchCon clearfix">
          <Checkbox class="fl f12" v-model="isShowHide"> 显示已退出的进程</Checkbox>
          <Button class="fr" type="primary" style="margin-left:10px;" @click="reshFn">刷新</Button>
          <div class="fr f12">
            <Input v-model="searchVal" @keyup.enter.native="searchFn" placeholder="支持模糊搜索进程路径" style="width: 400px" clearable>
            <Button slot="append" icon="ios-search" @click="searchFn">搜索</Button>
            </Input>
          </div>
          <div class="fr tipsCon" v-if="index.length && searchVal">共<b class="blue f14">{{ index.length }}</b>条相关数据
          </div>
        </div>
        <Split v-model="split" mode="vertical" class="contentCon" id="tableTreeCon">
          <div slot="top" class="demo-split-pane" :style="{ 'height': tableHeight + 'px' }">
            <table class="headTable" border="0" style="width:calc(100% - 16px)">
              <tr>
                <th class="tal ells1" style="width:48%;">进程路径</th>
                <th class="tal ells1" style="width:5%;">进程ID</th>
                <th class="tal ells1" style="width:5%;">父进程ID</th>
                <th class="tal ells1" style="width:20%;">公司名称</th>
                <th class="tal ells1" style="width:10%;">创建时间</th>
                <th class="tal ells1" style="width:10%;">结束时间</th>
                <th class="tar">操作</th>
              </tr>
            </table>
            <no-data style="height:auto;padding-top:20px;padding-bottom:20px;" v-show="newData.length == 0 || loading"
              :nodata="newData.length == 0 && !loading" :loading="loading"></no-data>
            <virtual-list class="virtualCon" id="virtualCon" :columns="columns" :data-sources="newData"
              :data-component="itemCom" :data-key="'id'" :osStartTime="curData.osStartTime" :clientId="curData.id">
            </virtual-list>
            <Spin fix v-if="loading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
          </div>
          <div slot="bottom" class="logCon">
            <logListCom :splitVal="split" :key="reshKey"  :debug="curData.debug" :id="curData" ref="logListCom" />
          </div>
        </Split>
      </div>
    </div>
    <Modal
        v-model="visibleTime"
        title="历史开机记录"
       >
       <Timeline>
        <Timeline-item v-for="(item,index) in dataLine.runHistoryList" :key="index">
            <p class="time">{{item.date}}</p>
            <p class="content" @click="open(list)" v-for="(list,key) in item.list"  :key="key">{{ list }} <b v-if="curData.osStartTime == list">【当前】</b></p>
        </Timeline-item>
        </Timeline>
    </Modal>
  </div>
</template>
<script>
import {
  getProTree
} from '@/requests/proTree.js'
import { queryClientOnline} from '@/requests/debug'
import VirtualList from 'vue-virtual-scroll-list'
import ItemComponents from './item.vue'
import logListCom from './logList.vue'
import NoData from '_c/noData/noData'
export default {
  props: ['curData'],
  components: {
    VirtualList,
    logListCom,
    NoData
  },
  data () {
    return {
      visibleTime: false,
      visible: false,
      height: 400,
      split: 0.5,
      data2: [],
      columns: [
        {
          title: '进程路径',
          key: 'fullPath',
          tree: true,
          align: 'left',
          width: 500,
        },
        {
          title: '进程ID',
          key: 'pid',
          align: 'left',
          tooltip: true,

          width: 70
        },
        {
          title: '父进程ID',
          key: 'parentPid',
          align: 'left',
          tooltip: true,

          width: 70
        },
        {
          title: '公司名称',
          key: 'signName',
          align: 'left',
          tooltip: true,

          width: 120
        },
        {
          title: '文件说明',
          key: 'signName',
          align: 'left',
          tooltip: true,

          width: 120
        },
        {
          title: '文件版本',
          key: 'signName',
          align: 'left',
          tooltip: true,
          width: 100
        },
        {
          title: '数字签名公司名',
          key: 'signName',
          align: 'left',
          tooltip: true,

          width: 100
        },
        {
          title: '创建时间',
          key: 'createTime',
          align: 'left',
          tooltip: true,
          width: 120,

        },
        {
          title: '结束时间',
          key: 'endTime',
          align: 'left',
          tooltip: true,
          width: 120,
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
        },
      ],
      data: [
      ],
      searchVal: '',
      tableHeight: 300,
      isExpend: false,
      loading: false,
      itemCom: ItemComponents,
      newData: [],
      newList: [],
      isShowHide: false,
      // isShowHideVal: {
      //   isShowHide: false
      // },
      index: [],
      reshKey: '',
      dataLine: {}
    }
  },
  watch: {
    isShowHide () {
      // this.$store.dispatch('user/actionSetIsShowProcess', this.isShowHide)
      
      // if (this.searchVal != '') {
      //   this.getNewList()
      // }
    },
    visibleTime(){
      this.getOnline()
    },
    isExpend () {
      if (this.isExpend) {
        let el = document.getElementById('fullScreen')
        this.fullScreen(el)
      } else {
        this.exitFullScreen(document.documentElement)
      }
    },
    visible () {
      if (this.visible) {
        window.localStorage.setItem('clientId', this.curData.id)
        this.getProTree()
        window.localStorage.setItem('clientId', this.curData.id)
        setTimeout(() => {
          this.getHeight()
        }, 300)
      } else {
        this.$store.dispatch(
          'log/actionResetSelectPro',
          ''
        )
      }
    },
    // loading() {
    //   if (!this.loading) {
    //     this.scrollFn()
    //   }
    // },
    split () {
      setTimeout(() => {
        this.getHeight()
      }, 300)
    },
    '$store.state.log.refreshFn2' () {
      this.getProTree()
    },
    // '$store.state.log.selectPro'() {
    //   this.getProTree()
    // }
  },
  mounted () {
    let that = this
    window.addEventListener('resize', function() {
      that.getHeight()
      that.reshKey = new Date().getTime()
    })
  },
  methods: {
    open(val) {
      let json = {
        barId: this.curData.barId,
        barName: this.curData.barName,
        pcName: this.curData.pcName,
        id: this.curData.id,
        debug: this.curData.debug,
        hash: this.curData.hash,
        osStartTime: val
      }
      window.open('/v2/home/tree' + '?curData=' + JSON.stringify(json), '_blank', 'width=1000,height=800,left=100,top=100')
    },
    async getOnline () {
      let res = await queryClientOnline({
        barId: this.curData.barId,
        hash: this.curData.hash,
        osStartTime: ''
      })
      if (res.code == 200) {
        this.dataLine = res.data
        //this.getProTree()
      }
    },
    rowClickFn (val) {
      console.log(val)
    },
    async getProTree () {
      let xids = []
      this.$store.state.log.selectPro.forEach(el => {
        xids.push(el.xid)
      })
      this.loading = true
      // if (this.dataLine && this.dataLine.length > 0) {
      //   this.curData.osStartTime = this.dataLine.maxOsStartTime
      // }
      console.log(this.curData.osStartTime)
      let res = await getProTree({
        barId: this.curData.barId,
        hash: this.curData.hash,
        osStartTime: this.curData.osStartTime,
        isShowHide: this.isShowHide,
        info: this.searchVal,
        xids: xids
      })
      this.loading = false
      if (res.code == 200) {
        this.data = res.data
        this.getNewData()
      } else {
        this.data = []
      }
    },
    getNewList () {
      this.newList = []
      if (this.newData && this.newData.length) {
        this.newData.forEach(el => {
          this.newList.push(el)
          this.pushChildren(el)
        })
      }
      let index = []
      let newData = []
      if (this.isShowHide) {
        newData = [...this.newList]
      } else {
        this.newList.forEach(el => {
          if (el.status) {
            newData.push(el)
          }
        })
      }
      let flag = false
      newData.forEach((element, key) => {
        if (this.searchVal == '') {
          if (element.select) {
            index.push(key)
            return
          }
        } else {
          if (element.haf) {
            index.push(key)
          }
        }
        // if (element.fullPath.toUpperCase().indexOf(this.searchVal.trim().toUpperCase()) != -1) {
        //   index.push(key)
        // }
        // if (this.searchVal == '') {
        //   if (element.select && !flag) {
        //     this.index = index
        //     flag = true
        //     this.scrollFn()
        //     return
        //   }
        //   return
        // }
        // if (element.haf && !flag) {
        //   this.index = index
        //   flag = true
        //   this.scrollFn()
        //   return
        // }
      })
      this.index = index
      this.scrollFn()
    },
    pushChildren (arr) {
      if (arr.children && arr.children.length > 0) {
        arr.children.forEach(el => {
          this.newList.push(el)
          this.pushChildren(el)
        })
      }
    },
    getNewData () {
      this.loading = false
      this.newData = [...this.getIndex(this.data)]
      setTimeout(() => {
        this.getNewList()
      }, 500);
    },
    scrollFn() {
      if (this.index && this.index.length) {
        document.getElementById('virtualCon').scrollTop = (this.index[0] - 3) * 24
      }
    },
    // hideExitPro (arr) {
    //   let newArr = []
    //   if (this.isShowHide) {
    //     newArr = [...arr]
    //   } else {
    //     arr.forEach(el => {
    //       if (el.status) {
    //       }
    //     })
    //   }
    //   return
    // },
    getIndex (arr) {
      let newArr = [...arr]
      // newArr.forEach((element) => {
      //   element.isHaf = false
      //   element.isShowHide = false
      //   if (this.isShowHide) {
      //     element.isShowHide = true
      //   } else {
      //     element.isShowHide = false
      //   }
      //   if (element.fullPath.toUpperCase().indexOf(this.searchVal.toUpperCase().trim()) != -1 && this.searchVal.toUpperCase().trim() != '') {
      //     element.isHaf = true
      //   } else {
      //     element.isHaf = false
      //   }
      //   if (element.children && element.children.length > 0) {
      //     this.getIndex(element.children)
      //   }
      // })
      newArr = this.isExpendFn(newArr)
      return newArr
    },
    isExpendFn (arr) {
      arr.forEach(element => {
        if (element.isHaf) {
          element.expend = true
        } else {
          if (element.children && element.children.length > 0) {
            if (this.childrenExpen(element.children)) {
              element.expend = this.childrenExpen(element.children)
            }
          }
        }
      })
      return arr
    },
    childrenExpen (arr) {
      let isFalse = false
      arr.forEach(element => {
        if (element.isHaf) {
          isFalse = true
        } else {
          if (element.children && element.children.length > 0) {
            this.childrenExpen(element.children)
          }
        }
      })
      this.loading = false
      return isFalse
    },
    getHeight () {
      let el = document.getElementById('tableTreeCon')
      if (el != undefined && el.offsetHeight != undefined) {
        let hei = el.offsetHeight
        this.tableHeight = hei * this.split
      } else {
        setTimeout(() => {
          this.getHeight()
        }, 300)
      }
    },
    searchFn () {
      this.getProTree()
    },
    reshFn () {
      this.searchVal = ''
      this.getProTree()
    },
    expendFn () {
      this.isExpend = !this.isExpend
    },
    fullScreen (el) {
      var rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen

      var wscript
      if (typeof rfs != 'undefined' && rfs) {
        rfs.call(el)
        return
      }
      if (typeof window.ActiveXObject != 'undefined') {
        wscript = new ActiveXObject('WScript.Shell')
        if (wscript) {
          wscript.SendKeys('{F11}')
        }
      }
    },
    exitFullScreen (el) {
      var cfs =
          el.cancelFullScreen ||
          el.webkitCancelFullScreen ||
          el.mozCancelFullScreen ||
          el.exitFullScreen

      var wscript
      if (typeof cfs != 'undefined' && cfs) {
        cfs.call(el)
        return
      }
      if (typeof window.ActiveXObject != 'undefined') {
        wscript = new ActiveXObject('WScript.Shell')
        if (wscript != null) {
          wscript.SendKeys('{F11}')
        }
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.proTreeCon {
  left: 0;
  top: 0;
  background: rgba($color: #000000, $alpha: .5);
  z-index: 99;
  width: 100%;
  height: 100%;

  .inProTreeCon {
    width: 100%;
    height: 100%;
    background: #fff;
    min-height: 600px;
    overflow-y: auto;
    min-width: 1000px;

    &.expendMax {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
    }

    h3 {
      line-height: 40px;
      text-indent: 20px;
      border-bottom: 1px solid #eee;
    }

    .expend {
      right: 10px;
      top: 0;
    }

    .closeIncon {
      right: 10px;
    }
  }
}

.inCon {
  padding: 20px;
  box-sizing: border-box;
  height: calc(100% - 41px);

  .contentCon {
    height: calc(100% - 30px);
    margin-top: 10px;
  }

  .treeCon {
    width: 100%;
  }

}

.tipsCon {
  line-height: 30px;
  margin-right: 10px;
}

.logCon {
  width: 100%;
  height: 100%;
  padding-top: 10px;
  box-sizing: border-box;
}
</style>
<style lang="scss">
.proTreeCon {
  .ivu-tooltip-inner {
    max-width: none;
  }

  .ivu-split-pane.top-pane {
    overflow: hidden;
  }

  .treeCon {
    .ivu-table:before {
      display: none;
    }

    .ivu-table {
      .ivu-table-cell-tooltip {
        width: calc(100% - 30px);
      }

      border: 1px solid #dcdee2;

      .ivu-table-header thead tr th {
        text-align: left;
      }

      .ivu-table-cell-tree {
        text-align: center;
        border: none;
        width: 24px;
        height: 24px;
        line-height: 24px;
      }

      td {
        border: none;
      }

      .ivu-icon {
        font-size: 24px;
      }

      .ivu-icon-ios-add:before {
        content: "\F341";
      }

      .ivu-icon-ios-remove:before {
        content: "\F33D";

      }
    }
  }
}

.table1 {
  .ivu-table-tip {
    display: none;
  }
}

.virtualCon {
  height: calc(100% - 40px);
  overflow: hidden;
  overflow-y: auto;
}

.headTable {
  line-height: 40px;
  background: #f8f8f9;

  th {
    font-weight: bolder;
  }
}

.ivu-btn-primary {
  font-size: 12px;
}
</style>